import React from 'react'
import { Routes, Route } from '@front/squirtle'

import ImportListList from './List'
import ImportListDetails from './Details'

const ImportListPage = () =>
  <Routes>
    <Route index element={<ImportListList />} />
    <Route path='/:list_id' element={<ImportListDetails />} />
  </Routes>

export default React.memo(ImportListPage)
